module.exports = __webpack_public_path__ + "images/interview-hero-mobile.png";